import { faLayerGroup } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    MenuItemProps,
    MenuItem as MuiMenuItem,
    Radio,
    styled,
    Typography,
} from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { MapContext } from "src/contexts/map";
import { Type_Map_Formatted } from "src/types/map";

import { Type_Props_Mobile_View_Drawer } from "./MobileViewDrawer";

const MenuItem = styled(MuiMenuItem)<MenuItemProps>(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginLeft: theme.spacing(2),
}));

const MobileLayersList = ({ closeDrawer }: Type_Props_Mobile_View_Drawer) => {
    const { maps, selectedMap, updateSelectedMap } = useContext(MapContext);
    const { t } = useTranslation();

    return (
        <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box
                    component="span"
                    display="flex"
                    gap={2}
                    alignItems="center"
                >
                    <FontAwesomeIcon icon={faLayerGroup} />
                    <Typography>{t("header.layers")}</Typography>
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                {maps.map((map: Type_Map_Formatted) => (
                    <MenuItem
                        disableRipple
                        key={map.id}
                        value={map.id}
                        onClick={() => {
                            updateSelectedMap(map);
                            closeDrawer();
                        }}
                    >
                        {map.label}
                        <Radio checked={selectedMap?.id === map.id} />
                    </MenuItem>
                ))}
            </AccordionDetails>
        </Accordion>
    );
};

export default MobileLayersList;
